import { RouteObject } from 'react-router-dom';
import {
  AdminsTable,
  DataSetsTable,
  ErrorBoundary,
  GroupRoute,
  ResearchersTable,
  StudiesTable,
} from 'src/components';
import { UserGroup } from 'src/types/users';
import { OrganizationalUnitsDetailsPage } from './organizational-units-details-page';
import { OrganizationalUnitsPage } from './organizational-units-page';

export const organizationalUnitsRouter: RouteObject[] = [
  {
    path: 'organizational-units',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<OrganizationalUnitsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: 'organizational-units/:organizationId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<OrganizationalUnitsDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'researchers',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<ResearchersTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'admins',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<AdminsTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'studies',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<StudiesTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'datasets',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DataSetsTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
];
